// React import removed

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Mahragan Portal
            </h3>
            <p className="mt-4 text-base text-gray-500">
              St. Mary's Coptic Orthodox Church annual competition management system.
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Quick Links
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <a href="/" className="text-base text-gray-500 hover:text-gray-900">
                  Home
                </a>
              </li>
              <li>
                <a href="/competitions" className="text-base text-gray-500 hover:text-gray-900">
                  Competitions
                </a>
              </li>
              <li>
                <a href="/results" className="text-base text-gray-500 hover:text-gray-900">
                  Results
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Contact
            </h3>
            <p className="mt-4 text-base text-gray-500">
              For support or questions, please contact your church coordinator.
            </p>
          </div>
        </div>
        
        <div className="mt-8 border-t border-gray-200 pt-8">
          <p className="text-base text-gray-400 text-center">
            &copy; {new Date().getFullYear()} St. Mary's Coptic Orthodox Church. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer